import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';

// Components
import LargeButton from '../../../../../common/src/components/LargeButton';
import CircularIconButton from './CircularIconButton';
import { IconShoppingBasket } from 'wg-fe-ui';
import ImmoIconCart from '../../../../../../assets/images/immotheker/ImmoIconCart';
import { Box } from '@wegroup/design-system';
import useIsNewRoute from '../../../features/offers/hooks/useIsNewRoute';

interface Props {
  inBasketAmount: number;
  disabledText?: string;
  disabled?: boolean;
  Icon?: React.ReactElement;
  onClick: () => void;
  onCircularButtonClick: () => void;
}

const BottomBar: React.FC<React.PropsWithChildren<Props>> = ({
  inBasketAmount,
  disabledText,
  disabled,
  children,
  Icon,
  onClick,
  onCircularButtonClick,
  ...otherProps
}) => {
  const theme = useContext(ThemeContext);
  const isNewRoute = useIsNewRoute();

  if (isNewRoute) return null;

  return (
    <Wrapper isNewRoute={isNewRoute} {...otherProps}>
      {disabledText && <DisabledText>{disabledText}</DisabledText>}
      <Flex>
        <StyledLargeButton onClick={onClick} disabled={disabled} Icon={Icon}>
          {children}
        </StyledLargeButton>
        <CircularIconButton
          amount={inBasketAmount}
          onClick={onCircularButtonClick}
        >
          {theme['isImmo'] ? (
            <Box sx={{ svg: { w: '100%', h: '100%' } }} p="3">
              <ImmoIconCart color={theme.gray[300]} />
            </Box>
          ) : (
            <IconShoppingBasket color={theme.gray[300]} />
          )}
        </CircularIconButton>
      </Flex>
    </Wrapper>
  );
};

const DisabledText = styled.p`
  font-size: 1.6rem;
  text-align: center;
  color: ${({ theme }) => theme.labels.guaranteeText};
  margin-bottom: 0.8rem;
`;

const StyledLargeButton = styled(LargeButton)`
  flex-grow: 1;
  margin-right: 1.6rem;
  padding-right: 4.8rem;
  font-size: 1.6rem;
  line-height: 120%;
  word-break: break-word;
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
`;

const Wrapper = styled.div<{ isNewRoute?: boolean }>`
  z-index: 2;
  position: ${({ isNewRoute }) => (isNewRoute ? 'sticky' : 'relative')};
  bottom: 0;
  min-height: 8.8rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background: white;
  padding: 0.8rem 2.4rem;
`;

export default BottomBar;
